import { VerificationConfig } from '@xt/verification-sdk';
import { VERIFICATION_PROCESS_CONFIG } from './process-config';
import { IDENTIFICATION_STEPS_CONFIG } from './steps-config';

export * from './process-config';
export * from './steps-config';
export * from './config-data.service';
export * from './identification-types';
export * from './cards-config';
export * from './dialogs-config';

export const VERIFICATION_CONFIG: VerificationConfig = {
  processConfig: VERIFICATION_PROCESS_CONFIG,
  stepsConfig: IDENTIFICATION_STEPS_CONFIG,
};
